import api from '../lib/api';
import type { Paginated } from '../types';
import type { SalesTarget, SalesTargetInput } from '../types/crm';

// Single-record endpoints (show/create/update) return a JSON:API-style envelope:
// `{ data: { id, type, attributes: {...flat record...} } }`. List endpoints return
// flat records directly inside `data`. Mirrors operator.service.ts.

export const salesTargetService = {
  getAll: async (params?: Record<string, unknown>): Promise<Paginated<SalesTarget>> => {
    const response = await api.get<Paginated<SalesTarget>>('/sales_targets', { params });
    return response.data;
  },

  getById: async (id: number): Promise<SalesTarget> => {
    const response = await api.get<{ data: { attributes: SalesTarget } }>(`/sales_targets/${id}`);
    return response.data.data.attributes;
  },

  create: async (data: SalesTargetInput): Promise<SalesTarget> => {
    const response = await api.post<{ data: { attributes: SalesTarget } }>('/sales_targets', {
      sales_target: data,
    });
    return response.data.data.attributes;
  },

  update: async (id: number, data: Partial<SalesTargetInput>): Promise<SalesTarget> => {
    const response = await api.patch<{ data: { attributes: SalesTarget } }>(
      `/sales_targets/${id}`,
      { sales_target: data }
    );
    return response.data.data.attributes;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/sales_targets/${id}`);
  },
};

export default salesTargetService;
